<template>
    <transition name="fade">
    <div id="bgc-question">
        <Question1 v-if="questionNumber === 1" @next="question(2)"/>
        <Question2 v-if="questionNumber === 2" @next="question(3)"/>
        <Question3 v-if="questionNumber === 3" @next="question(4)"/>
        <QuestionResult1 v-if="questionNumber === 4" @go="plan(25)"/>
    </div>
    </transition>
</template>
<script>
    import Question1 from "@/components/Questions/Question1";
    import Question2 from "@/components/Questions/Question2";
    import Question3 from "@/components/Questions/Question3";
    import QuestionResult1 from '@/components/Questions/QuestionResult1';

    export default {
        components: {
            Question1,
            Question2,
            Question3,
            QuestionResult1,
        },
        name: 'Questions',
        data() {
            return {
                questionNumber: 1
            }
        },
        methods: {
            question(number) {
                this.questionNumber = number
            },
            plan(time) {
                this.$parent.video.currentTime = time;
                this.$parent.video.play()
            }
        },
    }
</script>
<style scoped lang="scss">

    @import "../assets/css/default";

    #bgc-question {
        background-color: #fff;
        position: fixed;
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
        z-index: 10;
    }
</style>